// src/components/common/HorizontalPillFilter.tsx

// --- NEW: Make the component generic ---
// T is a generic type that represents the type of our ID (e.g., number, string)
interface FilterItem<T> {
  id: T;
  name: string;
  /** Optional selected-state classes (e.g. league identity colors on the
   *  lobby's competition pills). Falls back to the standard gold. */
  activeClassName?: string;
}

interface HorizontalPillFilterProps<T> {
  items: FilterItem<T>[];
  selectedId: T;
  onSelect: (id: T) => void;
  label?: string;
  // Centers pills horizontally when they fit. Opt-in because flex+overflow-x-auto
  // + justify-center can hide the leftmost overflowing item, so only set this
  // when the consumer knows the pill set is short (e.g. league filter with 2-4 items).
  centered?: boolean;
}
// --- END NEW ---

const HorizontalPillFilter = <T extends string | number>({
  items,
  selectedId,
  onSelect,
  label,
  centered,
}: HorizontalPillFilterProps<T>) => {
  return (
    <div className="mb-6">
      {label && (
        <label className="block text-sm font-medium text-gray-400 mb-2 text-center">
          {label}
        </label>
      )}
      <div className={`flex items-center space-x-2 overflow-x-auto scrollbar-mobile-hide pb-2 -mb-2 ${centered ? 'justify-center' : ''}`}>
        {items.map((item) => (
          <button
            key={String(item.id)}
            onClick={() => onSelect(item.id)}
            className={`px-4 py-1.5 rounded-full text-sm font-semibold transition-all duration-200 whitespace-nowrap flex-shrink-0
              active:scale-95
              ${selectedId === item.id
                ? (item.activeClassName || 'bg-accent-yellow text-primary shadow-md')
                : 'bg-surface-card text-gray-300 hover:bg-primary-dark hover:text-white active:bg-primary-dark active:text-white'
              }
            `}
          >
            {item.name}
          </button>
        ))}
      </div>
    </div>
  );
};

export default HorizontalPillFilter;